import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-entity-select',
  templateUrl: './entity-select.component.html',
  styleUrls: ['./entity-select.component.css'],
  standalone: false
})
export class EntitySelectComponent extends TypeaheadBase implements OnInit {
  @Input() vm: any;
  // When true, the label shows as required; defaults to false (optional)
  @Input() required: boolean = false;
  // Optional placeholder text for the input
  @Input() placeholder: string = 'Select ...';
  // Filter modal list by AP (payable=true), AR (receivable=true), or All (no filter). Default: All.
  @Input() ledgerFilter: 'AP' | 'AR' | 'All' = 'All';

  @Output() testEntityEmit = new EventEmitter<string>();
  @Output() selectEntityModalEmit = new EventEmitter<string>();
  @Output() updateEntityEmit = new EventEmitter<string>();
  @Output() clearEntityEmit = new EventEmitter<void>();
  entityTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.filteredEntities, 10);

  get filteredEntities(): any[] {
    const list: any[] = this.vm?.entity ?? [];
    if (this.ledgerFilter === 'AP') {
      return list.filter(e => e?.payable === true);
    }
    if (this.ledgerFilter === 'AR') {
      return list.filter(e => e?.receivable === true);
    }
    return list;
  }

  constructor(public isFiltered: IsFilterOnService) {
    super();
  }

  ngOnInit() {
  }

  checkFiltered(fromEvent: string): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    // console.log('filter set to:' + filteredValue);
    this.vm.filtered = filteredValue;
    // console.log('changed:' + fromEvent);
    return filteredValue;
  }

  testEntity() {
    this.testEntityEmit.emit();
  }

  onEntityBlur(typeahead: any) {
    if (typeahead?.isPopupOpen?.()) {
      return;
    }
    this.testEntity();
    this.checkFiltered('blur');
  }

  updateEntity() {
    this.updateEntityEmit.emit();
  }

  selectEntityModal(entity) {
    this.selectEntityModalEmit.emit(entity);
  }

  onTypeaheadSelect(event: any) {
    const selected = event?.item;
    const name = selected?.name ?? (typeof selected === 'string' ? selected : null);
    this.selectEntityModal(name);
    this.testEntity();
    this.checkFiltered('typeahead-select');
  }

  onClearClicked() {
    try {
      if (this.vm && this.vm.entityFilter) {
        this.vm.entityFilter.name = '';
      }
    } catch {
    }

    this.clearEntity();
  }

  clearEntity() {
    this.clearEntityEmit.emit();
  }

}
